import { reactive, ref, watch } from 'vue';

interface UseContentHubLogoCreateDialogState {
	isOpen: boolean;
	wasSuccessfullyCreated: boolean;
}

const DEFAULT_STATE: UseContentHubLogoCreateDialogState = {
	isOpen: false,
	wasSuccessfullyCreated: false,
} as const;

const getDefaultState = () => ({ ...DEFAULT_STATE });

const state = reactive<UseContentHubLogoCreateDialogState>(getDefaultState());

function resetState() {
	Object.assign(state, getDefaultState());
}

const isRendered = ref<boolean>(false);

watch(() => state.isOpen, (isOpen) => {
	if (isOpen && !isRendered.value) isRendered.value = true;
});

export function useContentHubLogoCreateDialog() {
	function open() {
		state.isOpen = true;
		state.wasSuccessfullyCreated = false;
	}

	function markAsCreated() {
		state.wasSuccessfullyCreated = true;
	}

	return {
		state,
		open,
		markAsCreated,
		resetState,
		isRendered,
	};
}
